import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'

import { ContentTitle } from './Content'

export default function GraphSectionIntro({ title, ...rest }) {
  const theme = useTheme()

  return (
    <div
      css={{
        marginBottom: theme.space.large,
      }}
      {...rest}
    >
      <ContentTitle>{title}</ContentTitle>
    </div>
  )
}

GraphSectionIntro.propTypes = {
  title: PropTypes.string.isRequired,
}
